const STORAGE_PREFIX = 'stx-chatbot-admin-';
export const TOKEN_STORAGE_KEY = `${STORAGE_PREFIX}token`; //klic pod kterym se sessionstorage uklada auth token
export const SESSION_ID_STORAGE_KEY = `${STORAGE_PREFIX}session-id`; //klic pod kterym se localstorage uklada session id
